module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "titlepage"
    }
  }, [_c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "image",
      "src": "images/tp.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "stitle"
  }, [_c('em', [_vm._v("• The Complete Collection ·")])]), _vm._v(" "), _c('p', {
    staticClass: "stitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS BY")])]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_vm._v("William Trowbridge")]), _vm._v(" "), _c('p', {
    staticClass: "aut1"
  }, [_vm._v("art by")]), _vm._v(" "), _c('p', {
    staticClass: "aut2"
  }, [_vm._v("TIM MAYER")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/tp1.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 63
// module chunks = 0